import ApiService from "./ApiService";
import api, { endpoint } from "./api";

export async function apiGetOperations() {
  return api.get(endpoint.api_operation).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiPostBatch(params) {
  return api.post(endpoint.api_batch, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiGetBatch(uid) {
  return api.get(`${endpoint.api_batch}/${uid}`).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiPutBatch(params) {
  return api.put(endpoint.api_batch, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiDeleteBatch(uid) {
  return api.delete(`${endpoint.api_batch}/${uid}`).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiGetFreeTime(params) {
  return api.get(endpoint.api_free_time, { params: params }).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiFreeTimeCreate(params) {
  return api.post(endpoint.api_free_time, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiOraculoTalk(params) {
  return api.post(endpoint.api_ai_oraculo_talk, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiUpdateFreeTime(params) {
  return api.put(endpoint.api_free_time, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiDeleteFreeTime(uid) {
  return api.delete(`${endpoint.api_free_time}/${uid}`).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiDeleteShipmentOrderItem(uid) {
  return api
    .delete(`${endpoint.api_shipment_order_items}/${uid}`)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetModals(params) {
  return api.get(endpoint.api_modal, { params: params }).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiGetCheckShippingAgent(params) {
  return api
    .get(endpoint.api_check_shipping_agent, { params: params })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiGetCheckQuotationAgent(params) {
  return api
    .get(endpoint.api_check_quotation_agent, { params: params })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiSaveModal(params) {
  return api.post(endpoint.api_modal, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetFreightTypes(params) {
  return api
    .get(endpoint.api_freightType, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetCurrencies(params) {
  return api.get(endpoint.api_currency, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetCurrencyQuote(params) {
  return api
    .get(endpoint.api_currency_quote, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSendProposal(params) {
  return api
    .post(endpoint.api_send_proposal, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSaveCurrency(params) {
  return api.post(endpoint.api_currency, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetSuppliers(params) {
  return api.get(endpoint.api_suppliers, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiAddSuppliers(params) {
  return api.post(endpoint.api_suppliers, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiUpdateSuppliers(params) {
  return api.put(endpoint.api_suppliers, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiDeactivateSuppliers(uid) {
  return api.patch(`${endpoint.api_suppliers}/${uid}`).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiDeactiveAgent(uid) {
  return api.patch(`${endpoint.api_agent_deactive}/${uid}`).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiDeactivateCustomerParameter(uid) {
  return api
    .patch(`${endpoint.api_customer_parameter}/${uid}`)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetPaymentStatus() {
  return api.get(endpoint.api_paymentStatus).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetTaxes() {
  return api.get(endpoint.api_tax).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetExpenses(params) {
  return api.get(endpoint.api_expense, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetServiceTypes() {
  return api.get(endpoint.api_serviceType).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetQuotationStatus() {
  return api.get(endpoint.api_quotation_status).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetShipmentStatus() {
  return api.get(endpoint.api_shipment_status).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetShipmentResponsibles() {
  return api.get(endpoint.api_shipment_responsibles).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetCustomerCarrier(params) {
  return api
    .get(endpoint.api_customer_carrier, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetCarrier(params) {
  return api.get(endpoint.api_carrier, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetPendingReport(params) {
  return api
    .get(endpoint.api_pending_report, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetInternalIdExists(params) {
  return api
    .get(endpoint.api_internalid_exists, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetCountries(params) {
  return api.get(endpoint.api_country, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSaveCountries(params) {
  return api.post(endpoint.api_country, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetMarketNews(params) {
  return api.get(endpoint.api_marketNews, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSaveMarketNews(params) {
  return api.post(endpoint.api_marketNews, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetAgents(params) {
  return api.get(endpoint.api_agents, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiAuthPartner(params) {
  return api.post(endpoint.api_authenticate_partner, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetCustomerNotifications(params) {
  return api.get(endpoint.api_customer_notifications_shipment_step, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiPutCustomerNotificationShipmentStepSwitchIsActive(id, params) {
  return api.put(`${endpoint.api_customer_notifications_shipment_step}/${id}`, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetShipmentcashItem(params) {
  return api
    .get(endpoint.api_shipment_cash_item, { params: params })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiGetPendingCategories(params) {
  return api
    .get(endpoint.api_pending_category, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetSubpendingCategories(params) {
  return api
    .get(endpoint.api_subpending_category, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetSubpendingCategoriesByCategoryId(categoryId) {
  return api
    .get(
      endpoint.api_subpending_category_by_category_id +
        `/${categoryId}?pageSize=50`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetUsers(params) {
  return api.get(endpoint.api_users, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetUsersDropdown(params) {
  return api
    .get(endpoint.api_users_dropdown, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetUsersByCustomer() {
  return api.get(endpoint.api_users_from_customer).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSaveAgents(params) {
  return api.post(endpoint.api_agents, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSavePendingCategories(params) {
  return api.post(endpoint.api_pending_category, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSaveSubpendingCategories(params) {
  return api.post(endpoint.api_subpending_category, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSaveCustomerCarrier(params) {
  return api.post(endpoint.api_customer_carrier, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiDeleteCustomerCarrier(uid) {
  return api
    .delete(`${endpoint.api_customer_carrier}/${uid}`)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSaveCarrier(params) {
  return api.post(endpoint.api_carrier, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiAuthResetInternal(params) {
  return api
    .post(endpoint.api_authenticate_reset_internal, params)
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiSaveExpenses(params) {
  return api.post(endpoint.api_expense, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetIntegrators(params) {
  return api
    .get(endpoint.api_integrators, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetPartners(params) {
  return api.get(endpoint.api_partners, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiDeletePartner(uid) {
  return api.delete(`${endpoint.api_partners}/${uid}`).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetReports(params) {
  return api.get(endpoint.api_reports, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSavePartners(params) {
  return api.post(endpoint.api_partners, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSaveReports(params) {
  return api.post(endpoint.api_reports, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetContainerTypes(params) {
  return api
    .get(endpoint.api_containerType, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSaveContainerTypes(params) {
  return api.post(endpoint.api_containerType, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetDocumentTypes(params) {
  return api
    .get(endpoint.api_documentType, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetDashboardShipmentMonthByModal(params) {
  return api
    .get(endpoint.api_shipment_month_by_modal, { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetDashboardShipmentByEta(params) {
  return api
    .get(endpoint.api_shipment_month_by_eta, { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetDashboardShipmentByRoute(params) {
  return api
    .get(endpoint.api_shipment_month_by_route, { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetDashboardShipmentByRoute2(params) {
  return api
    .get(endpoint.api_shipment_month_by_route_2, { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetDashboardShipmentByCreatedAt(params) {
  return api
    .get(endpoint.api_shipment_by_created_at, { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetDashboardProcessos(params) {
  return api
    .get(endpoint.api_dashboard + '/processos', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetShipmentsGerentialDashboard(params) {
  return api
    .get(endpoint.api_dashboard + '/shipments-gerential-dashboard', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetExpectedArrivalRisk(params) {
  return api
    .get(endpoint.api_expected_arrival_risk, { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetVolumeAndTrends(params) {
  return api
    .get(endpoint.api_dashboard + '/volume-and-trends', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetOperationalFunnel(params) {
  return api
    .get(endpoint.api_dashboard + '/operational-funnel', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetDashboardShipmentGrossWeightSum(params) {
  return api
    .get(endpoint.api_shipments_gross_weight_sum, { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetDashboardShipmentsWithoutVisibleLogistic(params) {
  return api
    .get(endpoint.api_dashboard + '/shipments-without-visible-logistic', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetShipmentBlindSpots(params) {
  return api
    .get(endpoint.api_dashboard + '/blind-spots', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetMonthlyCargoProfile(params) {
  return api
    .get(endpoint.api_dashboard + '/monthly-cargo-profile', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetMonthlyFreightComparison(params) {
  return api
    .get(endpoint.api_dashboard + '/monthly-freight-comparison', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetCustomerDashboardTarget(params) {
  return api
    .get(endpoint.api_customer_dashboard_target, { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiUpsertCustomerDashboardTarget(params) {
  return api.post(endpoint.api_customer_dashboard_target, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiGetCostPerKgAnalysis(params) {
  return api
    .get(endpoint.api_dashboard + '/cost-per-kg-analysis', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}


export async function apiGetMonthlyLeadTimeAnalysis(params) {
  return api
    .get(endpoint.api_dashboard + '/monthly-lead-time-analysis', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}


export async function apiGetContainerCostAnalysis(params) {
  return api
    .get(endpoint.api_dashboard + '/container-cost-analysis', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}


export async function apiGetContainerOccupancyAnalysis(params) {
  return api
    .get(endpoint.api_dashboard + '/container-occupancy-analysis', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}


export async function apiGetContainerWeightUtilization(params) {
  return api
    .get(endpoint.api_dashboard + '/container-weight-utilization', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}


export async function apiGetLeadTimeComparison(params) {
  return api
    .get(endpoint.api_dashboard + '/lead-time-comparison', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetLeadTimeTargetComparison(params) {
  return api
    .get(endpoint.api_dashboard + '/lead-time-target-comparison', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetWeeklyFreightByOrigin(params) {
  return api
    .get(endpoint.api_dashboard + '/weekly-freight-by-origin', { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}


export async function apiGetDashboardShipmentFreightAmountSum(params) {
  return api
    .get(endpoint.api_shipments_freight_amount_sum, { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetDashboardRouteReview(params) {
  return api
    .get(endpoint.api_dashboard_route_review, { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetDashboardShipmentsInTransportation(params) {
  return api
    .get(endpoint.api_shipments_in_transportation, { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetShipmentsTotalLoadAmount(params) {
  return api
    .get(endpoint.api_shipment_load_amount, { params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetPlaformDashboardUse(params) {
  return api
    .get(endpoint.api_platform_dashboard_use, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetVolumetryByDestination(params) {
  return api
    .get(endpoint.api_dashboard_volumetry_by_destination, { params: params })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiGetPlannedAndDone(params) {
  return api
    .get(endpoint.api_dashboard_planned_and_done, { params: params })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiGetOperationalCost(params) {
  return api
    .get(endpoint.api_dashboard_operational_cost, { params: params })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiOperationalSLAGetAll(params) {
  return api
    .get(endpoint.api_operationalSla, { params: params })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiCreateOperationalSLA(params) {
  return api.post(endpoint.api_operationalSla, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiUpdateOperationalSLA(params) {
  return api.put(endpoint.api_operationalSla, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiDeleteOperationalSLA(uid) {
  return api.delete(`${endpoint.api_operationalSla}/${uid}`).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiGetIncoterms(params) {
  return api.get(endpoint.api_incoterm, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSaveIncoterms(params) {
  return api.post(endpoint.api_incoterm, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetLoadTypes(params) {
  return api.get(endpoint.api_loadType, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSaveLoadTypes(params) {
  return api.post(endpoint.api_loadType, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetLocationTypes(params) {
  return api
    .get(endpoint.api_locationType, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSaveLocationsTypes(params) {
  return api.post(endpoint.api_locationType, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetCustomers(params) {
  return api.get(endpoint.api_customer, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSaveCustomers(params) {
  return api.post(endpoint.api_customer, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetLocations(params) {
  return api.get(endpoint.api_location, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetCustomerSupplier(params) {
  return api
    .get(endpoint.api_customer_supplier, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSaveLocations(params) {
  return api.post(endpoint.api_location, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetPackageTypes(params) {
  return api
    .get(endpoint.api_packageType, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSavePackageTypes(params) {
  return api.post(endpoint.api_packageType, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiMilestoneTypes() {
  return api.get(endpoint.api_milestone_type).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetOrderItems(params) {
  return api
    .get(endpoint.api_order_items, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetShipmentOrderItems(params) {
  return api
    .get(endpoint.api_shipment_order_items, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetShipmentOrderItemsByShipmentId(params) {
  return api
    .get(endpoint.api_shipment_order_items_list_by_shipment, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchOrderItemsDisable(items) {
  return api.patch(endpoint.api_order_items, items).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiPatchOrderItemLine({ uid, ...items }) {
  return api
    .patch(`${endpoint.api_order_items}/${uid}/Line`, `"${items?.orderLine}"`)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchOrderReadinessDate({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/ReadinessDate`,
      `"${new Date(items?.cargoReadinessDate).toISOString()}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchOrderValueUnitCalculated({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/ValueUnitCalculated`,
      `"${items?.valueUnitCalculated
        .toString()
        .replace(/\./g, "")
        .replace(",", ".")}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchOrderShipmentDate({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/OrderShipmentDate`,
      `"${new Date(items?.orderShipmentDate).toISOString()}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchCustomerBillingDate({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/CustomerBillingDate`,
      `"${new Date(items?.customerBillingDate).toISOString()}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchCustomerBillingDateCurrent({ uid, ...items }) {
 
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/CustomerBillingDateCurrent`,
      `"${new Date(items?.CustomerBillingDateCurrent).toISOString()}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchReceiptCustomerDate({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/ReceiptCustomerDate`,
      `"${new Date(items?.receiptCustomerDate).toISOString()}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchOutputData({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/OutputData`,
      `"${new Date(items?.outputData).toISOString()}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchUpdateDetailsAfterApprovedCustomerProposal({
  customerProposalId,
  customerProposalItemId,
  ...params
}) {
  return api
    .put(
      `${endpoint.api_customer_proposal_update_details_after_approved}/${customerProposalId}/${customerProposalItemId}`,
      params
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchOrderReleaseDate({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/OrderReleaseDate`,
      `"${new Date(items?.orderReleaseDate).toISOString()}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchControlConference({ uid, ...items }) {
  let valor = `"${items?.controlConference ?? ""}"`;

  return api
    .patch(`${endpoint.api_order_items}/${uid}/ControlConference`, valor)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchControlReference({ uid, ...items }) {
  let valor = `"${items?.controlReference ?? ""}"`;

  return api
    .patch(`${endpoint.api_order_items}/${uid}/ControlReference`, valor)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apicustomerCustomerId({ uid, ...items }) {
  let valor = `"${items?.customerCustomerId ?? ""}"`;

  return api
    .patch(`${endpoint.api_order_items}/${uid}/CustomerCustomer`, valor)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchSupplierDeadline({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/SupplierDeadline`,
      `${items?.supplierDeadline}`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchInvoice({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/Invoice`,
      JSON.stringify(String(items?.invoice))
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchCostCenter({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/CostCenter`,
      `${items?.costCenter}`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchExpectedReadinessDate({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/ExpectedReadinessDate`,
      `"${new Date(items?.expectedReadinessDate).toISOString()}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetShipmentDI(uid) {
  return api
    .get(`${endpoint.api_shipment_di}/${uid}/ShipmentId`)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetAwaitingArrivalinTransit(params) {
  return api
    .get(`${endpoint.api_shipment_get_awaiting_arrival_intransit}`, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetDermugerFinished(params) {
  return api
    .get(`${endpoint.api_shipment_get_dermuge_finished}`, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetDemurrageCost(params) {
  return api.get(`${endpoint.api_shipment_get_dermuge_cost}`, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetShipmentFreeTime(uid) {
  return api
    .get(`${endpoint.api_shipment_free_time}/${uid}/ShipmentId`)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetShipmentFreeTimeList(params) {
  return api.get(`${endpoint.api_shipment_free_time}`, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetShipmentFreeTimeContainerReturn(params) {
  return api
    .get(`${endpoint.api_shipment_free_time_container_return}`, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchInitialReadinessDate({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/InitialReadinessDate`,
      `"${new Date(items?.initialReadinessDate).toISOString()}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchActualReadinessDate({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/ActualReadinessDate`,
      `"${new Date(items?.actualReadinessDate).toISOString()}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiModalId({ uid, ...items }) {
  return api
    .patch(`${endpoint.api_order_items}/${uid}/ModalId`, items?.modalId)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPackageType({ uid, ...items }) {
  return api
    .patch(`${endpoint.api_order_items}/${uid}/PackageType`, items?.packageType)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPackage({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/package`,
      `"${items?.packaging}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchDeliveryTimeOnOrderItem({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/deliveryTime`,
      `"${items?.deliveryTime}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchObservation({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/observation`,
      `"${items?.observation}"`
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiIdentifierLi({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/IdentifierLi`,
      items?.identifierLi
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiCertificateAnalyze({ uid, ...items }) {
  return api
    .patch(
      `${endpoint.api_order_items}/${uid}/CertificateAnalyze`,
      items?.certificateAnalyze
    )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPatchLocation({ uid, ...items }) {
  return api
    .patch(`${endpoint.api_order_items}/${uid}/Location`, items)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetCustomerManufacturer(params) {
  return api
    .get(endpoint.api_customer_manufacturer, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetCustomerParameter(params) {
  return api
    .get(endpoint.api_customer_parameter, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSaveCustomerManufacturer(params) {
  return api.post(endpoint.api_customer_manufacturer, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSaveAdjustmentShipmentOrderItems(params) {
  return api
    .post(endpoint.api_shipment_adjustment_orderitems, params)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiUpdateCustomerManufacturer(uid, params) {
  return api
    .put(`${endpoint.api_customer_manufacturer}/${uid}`, params)
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiDeleteCustomerManufacturer(uid) {
  return api
    .delete(`${endpoint.api_customer_manufacturer}/${uid}`)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSaveCustomerParameter(params) {
  return api.post(endpoint.api_customer_parameter, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetCustomerProvider(params) {
  return api
    .get(endpoint.api_customer_provider, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetTrixActivities(params) {
  return api
    .get(endpoint.api_trix_activity, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetTrixParameterization(params) {
  return api
    .get(endpoint.api_template_shipment_activity, { params: params } )
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiUpdateTrixActivity(uid, params) {
 
  return api
    .put(endpoint.api_trix_activity + `/${uid}`, params)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetAllFromCustomerUser(params) {
  return api
    .get(endpoint.api_customerUser_get_from_customer, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetFreteAereo(params) {
  return api
    .get(endpoint.api_dashboard + '/frete-aereo', { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetPendingShipmentActivity(params) {
  return api
    .get(endpoint.api_pending_shipment_activity, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSaveCustomerProvider(params) {
  return api.post(endpoint.api_customer_provider, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetCustomerProduct(params) {
  return api
    .get(endpoint.api_customer_product, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSaveCustomerProduct(params) {
  return api.post(endpoint.api_customer_product, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetCustomerTerminal(params) {
  return api
    .get(endpoint.api_customer_terminal, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSaveCustomerTerminal(params) {
  return api.post(endpoint.api_customer_terminal, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiImportCustomerTerminal(params) {
  return api.post(endpoint.api_customer_terminal_import, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetCustomerCustomer(params) {
  return api
    .get(endpoint.api_customer_customer, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiSaveCustomerCustomer(params) {
  return api.post(endpoint.api_customer_customer, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetAddressByCep(cep) {
  return fetch(endpoint.api_cep_search + `/${cep}/json`).then((result) => {
    return result;
  });
}

export async function apiGetCustomerProposal(params) {
  return api
    .get(endpoint.api_customer_proposal, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}


export async function apiPatchUpdateCreatedAt(uid, params) {
  return api.patch(`${endpoint.api_customer_proposal}/${uid}/update-createdat`, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiSaveCustomerProposal(params) {
  return api.post(endpoint.api_customer_proposal, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetCustomerNotificationOrderItem(params) {
  return api
    .get(endpoint.api_customer_notification_order_item, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPostCustomerNotificationOrderItem(params) {
  return api.post(endpoint.api_customer_notification_order_item, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiPutCustomerNotificationOrderItem(params) {
  return api.put(endpoint.api_customer_notification_order_item, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiDeleteCustomerNotificationOrderItem(uid) {
  return api.delete(endpoint.api_customer_notification_order_item + `/${uid}`).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiDeleteProposal(uid) {
  return api
    .delete(`${endpoint.api_customer_proposal}/${uid}`)
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetUserProfileByUid(params) {
  return api.get(`${endpoint.api_user_profile}/${params}`).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiAddUserProfile(params) {
  return api.post(endpoint.api_user_profile, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetUserProfiles(params) {
  return api
    .get(endpoint.api_user_profiles, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiUpdateUserProfile(uid, params) {
  return api
    .put(endpoint.api_user_profile + `/${uid}`, params)
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiUpdateTrixActivityRule(id, data) {
  return api
    .put(endpoint.api_trix_activity_rule + `/${id}`, data)
    .then((result) => {
      return result?.data;
    });
}

export async function apiUpdateNotificationShipmentStepRule(id, data) {
  return api
    .put(endpoint.api_notification_shipment_step_rule + `/${id}`, data)
    .then((result) => {
      return result?.data;
    });
}

export async function apiUpdateOrderItem(params) {
  return api.put(endpoint.api_update_order_items, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiUpdateCustomerParameter(params) {
  return api.put(endpoint.api_customer_parameter, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiGetShipmentJourneySteps(params) {
  return api
    .get(endpoint.api_shipment_journey_steps, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetShipmentActivity(params) {
  return api
    .get(endpoint.api_shipment_activity, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetShipmentActivityFromUser(params) {
  return api
    .get(endpoint.api_shipment_activity_from_user, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiCreateShipmentActivity(params) {
  return api.post(endpoint.api_shipment_activity, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiGetShipmentActivityMessage(params) {
  return api
    .get(endpoint.api_shipment_activity_message, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiCreateShipmentActivityMessage(params) {
  return api
    .post(endpoint.api_shipment_activity_message, params)
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiUpdateShipmentActivity(params) {
  return api.put(endpoint.api_shipment_activity, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiImportShipment(params) {
  return api.post(endpoint.api_import_shipment, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiUpdateShipmentImport(params) {
  return api
    .post(endpoint.api_update_shipment_import, params)
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiShipmentUpdatePlataform(params) {
  return api
    .post(endpoint.api_update_activity_status, params)
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiAgentImport(params) {
  return api.post(endpoint.api_agent_import, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiPartnerImport(params) {
  return api.post(endpoint.api_partner_import, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiSupplierImport(params) {
  return api.post(endpoint.api_supplier_import, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiGetTemplateImportShipment() {
  return api
    .get(endpoint.api_template_import_shipment, { responseType: "blob" })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiGetTemplateImportOperationalSLA() {
  return api
    .get(endpoint.api_template_import_operationalSLA, { responseType: "blob" })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiImportOperationalSLA(params) {
  return api.post(endpoint.api_import_operationalSLA, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiGetTemplateUpdateShipment() {
  return api
    .get(endpoint.api_template_update_shipment, { responseType: "blob" })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiGetTemplateImportAgent() {
  return api
    .get(endpoint.api_template_import_agent, { responseType: "blob" })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiGetTemplateImportPartner() {
  return api
    .get(endpoint.api_template_import_partner, { responseType: "blob" })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiGetTemplateImportSupplier() {
  return api
    .get(endpoint.api_template_import_supplier, { responseType: "blob" })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiPostMatchLocation(params) {
  return api.post(endpoint.api_match_location, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiPostMatchCarrier(params) {
  return api.post(endpoint.api_match_carrier, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiPostEarlyPayment(params) {
  return api.post(endpoint.api_post_early_payment, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiGetInvoices(shipmentId) {
  return api.get(endpoint.api_shipment_invoice + `/${shipmentId}`).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiDeleteInvoice(uid) {
  return api.delete(endpoint.api_shipment_invoice + `/${uid}`).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiDeleteInvoiceItem(uid) {
  return api.delete(endpoint.api_shipment_invoice_item + `/${uid}`).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiUpdateInvoiceItem(params) {
  return api.put(endpoint.api_shipment_invoice_item, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiInsertInvoiceItem(params) {
  return api.post(endpoint.api_shipment_invoice_item, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiUpdateShipmentInvoice(params) {
  return api.put(endpoint.api_shipment_invoice, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiAttachInvoiceToShipment(shipmentId, tomProcessedFileId) {
  return api.post(endpoint.api_shipment_invoice + `/tom/${shipmentId}`, tomProcessedFileId).then((result) => {  
    if (result.data) return result.data;
  });
}

//packlist
export async function apiGetShipmentPackingList(shipmentId) {
  return api.get(endpoint.api_shipment_packing_list + `/${shipmentId}`).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiDeletePackingList(uid) {
  return api.delete(endpoint.api_shipment_packing_list + `/${uid}`).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiDeletePackingListItem(uid) {
  return api.delete(endpoint.api_shipment_packing_list_item + `/${uid}`).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiUpdatePackingListItem(params) {
  return api.put(endpoint.api_shipment_packing_list_item, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiInsertPackingListItem(params) {
  return api.post(endpoint.api_shipment_packing_list_item, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiUpdatePackingList(params) {
  return api.put(endpoint.api_shipment_packing_list, params).then((result) => {
    if (result.data) return result.data;
  });
}



export async function apiAttachTomToShipment(shipmentId, tomProcessedResponses) {
  return api.post(endpoint.api_ai_tom + `/attach/${shipmentId}`, tomProcessedResponses).then((result) => {  
    if (result.data) return result.data;
  });
}

export async function apiGetInfoToPayment(params) {
  return api.get(endpoint.api_get_load_info_payment, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiGetEarlyPayment(params) {
  return api
    .get(endpoint.api_get_early_payment, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetAllPaymentShipmentIntegration(params) {
  return api
    .get(endpoint.api_get_all_payment_shipment_integration, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiPutChangeStatusPayment(params) {
  return api.put(`${endpoint.api_get_early_payment}`, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

// export async function apiPutAllApprovePayment(params) {
//   return api.put(`${endpoint.api_get_early_payment}`, params).then((result) => {
//     if (result.data) {
//       return result.data;
//     }
//   });
// }

export async function apiEarlyPaymentAddAttachment(params) {
  return api
    .post(endpoint.api_post_early_payment_upload, params)
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiGetDownloadDocumentPayment(params) {
  return api
    .get(endpoint.api_get_download_document_payment, { params: params })
    .then((result) => {
      if (result.data) return result.data;
    });
}

export async function apiDeletePayment(params) {
  return api.post(endpoint.api_delete_early_payment, params).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetPaymentCalculate(params) {
  return api
    .get(endpoint.api_get_early_payment_calculate, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetCockpitDashboardFinance(params) {
  return api
    .get(endpoint.api_get_cockpit_dashboard_finance, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetLastBillsPaid(params) {
  return api
    .get(endpoint.api_get_last_bills_paid, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetTopPaymentProviders(params) {
  return api
    .get(endpoint.api_get_top_payment_providers, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetExpensesByMonth(params) {
  return api
    .get(endpoint.api_get_expenses_by_month, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetPaymentvolumetryByStatus(params) {
  return api
    .get(endpoint.api_get_payment_volumetry_by_status, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetRepresentationByProviders(params) {
  return api
    .get(endpoint.api_get_representation_by_providers, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetComparisonOperatingCosts(params) {
  return api
    .get(endpoint.api_get_comparison_operating_costs, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetExpenseCalendar(params) {
  return api
    .get(endpoint.api_get_expense_calendar, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetExpectedActualOperatingExpenses(params) {
  return api
    .get(endpoint.api_get_expected_actual_operating_expenses, {
      params: params,
    })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

export async function apiGetAllDashPatner() {
  return api.get(endpoint.api_get_partner_dash).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiPutErpIntegration(params) {
  return api.put(`${endpoint.api_put_erp_integration}`, params).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiPatchPaymentForecast({ uid, ...items }) {
  return api.patch(`${endpoint.api_early_payment}/${uid}/payment-forecast`, `"${items?.paymentForecast}"`).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiPostSendPaymentForecast(uid) {
  return api.post(`${endpoint.api_early_payment}/${uid}/send-payment-forecast`).then((result) => {
    if (result.data) return result.data;
  });
}

export async function apiPatchPaymentDueDate({ uid, ...items }) {
  return api.patch(`${endpoint.api_early_payment}/${uid}/due-date`, `"${items?.dueDate}"`).then((result) => {
    if (result.data) return result.data;
  });
}


export async function apiGetContainerByShipmentStatus(params) {
  return api
    .get(endpoint.api_get_container_by_shipment_status, { params: params })
    .then((result) => {
      if (result.data) {
        return result.data;
      }
    });
}

// Tracking Control Tower Services
export async function apiGetTrackingControl() {
  return api.get(endpoint.api_tracking_control).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetBookingTracking() {
  return api.get(endpoint.api_booking_tracking).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetBookingTrackingDashboard() {
  return api.get(endpoint.api_booking_tracking_dashboard).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetBookingTrackingList() {
  return api.get(endpoint.api_booking_tracking_list).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiReprocessShipment(bookingTrackingData) {
  return api.post(endpoint.api_booking_tracking_reprocess, bookingTrackingData).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiReprocessShipmentBatch(bookingTrackingList) {
  return api.post(endpoint.api_booking_tracking_reprocess_batch, bookingTrackingList).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

// Integration Control Dash (Monitoramento - Integrações) Services
export async function apiGetIntegrationControlDashDashboard(params) {
  return api.get(endpoint.api_integration_control_dash_dashboard, { params: params }).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetIntegrationControlDashList() {
  return api.get(endpoint.api_integration_control_dash_list).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetDuimpControlDashboard() {
  return api.get(endpoint.api_duimp_control_dashboard).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetDuimpControlList() {
  return api.get(endpoint.api_duimp_control_list).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetDuimpControlShipmentList(duimpNumber) {
  return api.get(endpoint.api_duimp_control + `/integration-key/${duimpNumber}`).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiReprocessIntegration(integrationControlDto) {
  return api.post(endpoint.api_integration_control_reprocess, integrationControlDto).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}

export async function apiGetIntegrationSystemList() {
  return api.get(endpoint.api_integration_system_list).then((result) => {
    if (result.data) {
      return result.data;
    }
  });
}
